<template>
  <DataGetter
    :url="url"
    :params="{
      Country: countries,
      CODE_INDICATOR: indicator,
      CODE_SECTOR: sector,
      CODE_PRODUCT: product || selectedProduct,
      CODE_UNIT: unit,
    }"
    :initialData="[]"
    :formatter="monthly ? mapMonthly : null"
    @fetched="setUnits"
    lazy
    v-slot="{ data }"
  >
    <DataSlicer
      :data="data"
      yAxisDimension="Country"
      xAxisDimension="CODE_YEAR"
      valueDimension="Value"
      no-single-value
      :no-x-numeric="!!monthly"
      v-slot="{ slicedData, xAxisCategories }"
    >
      <Chart
        :title="`${
          monthly
            ? `Monthly ${topicName} prices`
            : `${topicName} energy prices over time`
        }, ${baseCountry}`"
        :chartType="monthly || compareCountries.length > 0 ? 'line' : 'column'"
        :series="
          slicedData
            .map((series) => ({
              ...series,
              colorIndex: countries.indexOf(series.name),
            }))
            .sort((a, b) => a.colorIndex - b.colorIndex)
        "
        :units="units"
        :chartOptions="{
          chart: {
            height: 300,
          },
          plotOptions: {
            column: {
              stacking: undefined,
            },
            line: {
              marker: {
                enabled: !monthly,
              },
              label: {
                enabled: true,
              },
            },
          },
          yAxis: {
            min: 0,
          },
          xAxis: {
            type: monthly ? 'datetime' : 'number',
            tickPositions: monthly
              ? null
              : xAxisCategories.length < 10
              ? xAxisCategories.map((year) => parseInt(year))
              : xAxisCategories.reduce(
                  (ticks, year, i) =>
                    i === 0 ||
                    i === xAxisCategories.length - 1 ||
                    year % (half ? 5 : 2) === 0
                      ? [...ticks, parseInt(year)]
                      : ticks,
                  []
                ),
          },
        }"
        half
      >
        <ControlGroup>
          <DataGetter
            v-if="!product"
            :url="`${url}/list/CODE_PRODUCT`"
            :params="{
              Country: baseCountry,
              CODE_INDICATOR: indicator,
              CODE_SECTOR: sector,
              CODE_UNIT: unit,
            }"
            v-slot="{ data }"
            lazy
            :child-element-type="null"
          >
            <Dropdown
              v-if="data"
              label="Show product"
              :options="data"
              v-model="selectedProduct"
              reset-on-invalid
              fixed
            />
          </DataGetter>
          <DataGetter
            :url="`${url}/list/Country`"
            :params="{
              CODE_PRODUCT: product || selectedProduct,
              CODE_INDICATOR: indicator,
              CODE_SECTOR: sector,
              CODE_UNIT: unit,
            }"
            v-slot="{ data }"
            lazy
            :child-element-type="null"
          >
            <Multiselect
              v-if="data"
              label="Compare countries"
              :options="data"
              v-model="compareCountries"
              :maxItems="5"
              reset-on-invalid
              fixed
            />
          </DataGetter>
        </ControlGroup>
      </Chart>
    </DataSlicer>
  </DataGetter>
</template>

<script>
import {
  DataGetter,
  DataSlicer,
  ControlGroup,
  Dropdown,
  Multiselect,
} from "@international-energy-agency/vue-ui";
import { Chart } from "@international-energy-agency/vue-ui/highcharts";
export default {
  props: {
    baseCountry: {
      type: String,
      required: true,
    },
    sector: {
      type: String,
      required: true,
    },
    product: {
      type: String,
      required: false,
    },
    topicName: {
      type: String,
      required: true,
    },
    unit: {
      type: String,
      required: true,
    },
    monthly: {
      type: Boolean,
      default: false,
    },
    half: {
      type: Boolean,
      default: false,
    },
    url: {
      type: String,
      default: "https://api.iea.org/prices",
      required: false,
    },
  },
  components: {
    DataGetter,
    DataSlicer,
    ControlGroup,
    Dropdown,
    Multiselect,
    Chart,
  },
  watch: {
    sector(newSector, oldSector) {
      if (newSector !== oldSector) this.selectedProduct = null;
    },
  },
  data() {
    return {
      selectedProduct: "GASOLINE",
      compareCountries: [],
      units: "&nbsp;",
    };
  },
  computed: {
    countries() {
      return [this.baseCountry, ...this.compareCountries];
    },
    indicator() {
      const { monthly } = this;
      return monthly ? "PRICEMONTHLY" : "PRICE";
    },
  },
  methods: {
    setUnits(data) {
      this.units = data && data.length > 0 ? data[0].Unit : "";
    },
    mapMonthly(data) {
      return data
        .map((row) => ({
          ...row,
          CODE_YEAR: new Date(row.CODE_YEAR).getTime(),
        }))
        .sort((a, b) => a.CODE_YEAR - b.CODE_YEAR);
    },
  },
};
</script>